import {
  ArrowLeft,
  Copy,
  Edit,
  MessageSquare,
  Plus,
  Package,
  Printer,
  UserPlus,
  CalendarDays,
} from "lucide-react";
import { FC } from "react";
import { useDetailBookingStore, BookingTab } from "./detail-booking.store";
import { getStatusBadge } from "./booking-utils";
import { useNavigate } from "react-router-dom";
import { useBooking } from "~/store";
import { useClientStore } from "~/components/admin/client-management/clients/clients.store";

type Props = {};

export const HeaderBooking: FC<Props> = () => {
  const navigate = useNavigate();
  const { openBookingModal } = useBooking();
  const { openClientModal } = useClientStore();
  const { booking, setActiveTab, setShowServiceForm, setShowInventoryModal, setIsAddingNewService, setShowExpoModal } = useDetailBookingStore();

  const isQuickClient = !booking?.client && !!booking?.tempClientData;
  const isAppBooking = booking?.serviceTicket?.some((ticket: any) => 
    ticket.staffNotes && ticket.staffNotes.includes("=== CLIENT SERVICE REQUEST ===")
  );

  const handleEdit = () => {
    openBookingModal({
      bookingId: booking?.id,
    });
  };

  const handleDuplicate = () => {
    navigate(`/bookings/copy/${booking?.id}`);
  };

  const handlePrint = () => {
    console.log("Print booking:", booking?.id);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleAddService = () => {
    setActiveTab(BookingTab.SERVICES);
    setIsAddingNewService(true);
    setShowServiceForm(true);
  };

  const handleViewInventory = () => {
    setShowInventoryModal(true);
  };

  const handleConvertToClient = () => {
    if (booking?.tempClientData && booking?.id) {
      openClientModal(undefined, {
        prefillData: booking.tempClientData,
        bookingIdToLink: booking.id,
      });
    }
  };

  return (
    <div className="mb-6 flex flex-col md:flex-row md:justify-between md:items-center gap-4">
      <div className="flex items-center space-x-3">
        <button
          onClick={handleBack}
          className="p-2 hover:bg-white rounded-full border"
        >
          <ArrowLeft size={16} />
        </button>
        <div>
          <h1 className="text-2xl font-semibold flex items-center">
            Booking Details: {booking?.referenceNumber}
            <span className="ml-3">
              {booking?.status && getStatusBadge(booking?.status)}
            </span>
          </h1>
          <div className="h-2" /> {/* Visual space between elements */}
          <p className="text-2xl font-semibold flex items-center">
            {booking?.client?.companyName ||
              [booking?.client?.firstName, booking?.client?.lastName]
                .filter(Boolean)
                .join(" ")
                .trim() ||
              booking?.tempClientData?.name ||
              "Unnamed Client"}{" "}
            {booking?.tempClientData && !booking?.client && (
              <span className="ml-2 text-sm bg-orange-100 text-orange-700 px-2 py-0.5 rounded">New Lead</span>
            )}
            {isAppBooking && (
              <span className="ml-2 text-sm bg-orange-100 text-orange-700 px-2 py-0.5 rounded">APP BOOKING</span>
            )}
            {booking?.project?.name && ` • ${booking.project.name}`}
          </p>
        </div>
      </div>

      <div className="flex flex-wrap gap-2">
        {isQuickClient && (
          <button
            onClick={handleConvertToClient}
            className="px-3 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 flex items-center space-x-1"
          >
            <UserPlus size={16} />
            <span>Convert to Client</span>
          </button>
        )}
        {booking?.project && (
          <button
            onClick={() => setShowExpoModal(true)}
            className="px-3 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center space-x-1"
          >
            <CalendarDays size={16} />
            <span>Expo Mode</span>
          </button>
        )}
        <button
          onClick={handleAddService}
          className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center space-x-1"
        >
          <Plus size={16} />
          <span>Add Service</span>
        </button>
        <button
          onClick={handleViewInventory}
          className="px-3 py-2 border rounded-lg hover:bg-white flex items-center space-x-1"
        >
          <Package size={16} />
          <span>View Inventory</span>
        </button>
        <button
          onClick={handleEdit}
          className="px-3 py-2 border rounded-lg hover:bg-white flex items-center space-x-1"
        >
          <Edit size={16} />
          <span>Edit Booking Detail</span>
        </button>
        <button
          onClick={handleDuplicate}
          className="px-3 py-2 border rounded-lg hover:bg-white flex items-center space-x-1"
        >
          <Copy size={16} />
          <span>Duplicate</span>
        </button>
        <button
          onClick={handlePrint}
          className="px-3 py-2 border rounded-lg hover:bg-white flex items-center space-x-1"
        >
          <Printer size={16} />
          <span>Print</span>
        </button>
        <button className="px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center space-x-1">
          <MessageSquare size={16} />
          <span>Contact Client</span>
        </button>
      </div>
    </div>
  );
};
